type LogoProps = {
  variant?: 'dark' | 'light';
  size?: 'sm' | 'md' | 'lg';
};

const sizes = {
  sm: 'text-lg',
  md: 'text-xl',
  lg: 'text-2xl',
};

export default function Logo({ variant = 'dark', size = 'md' }: LogoProps) {
  const isLight = variant === 'light';
  return (
    <span className={`font-display font-bold ${sizes[size]} tracking-tight select-none`}>
      <span className={isLight ? 'text-white' : 'text-primary-600'}>email</span>
      <span className={isLight ? 'text-white/60' : 'text-slate-400'}>aze</span>
    </span>
  );
}
